'use client';

import { skipToken, useSuspenseQuery } from '@apollo/client';
import {
    ClientFeaturesFragmentFragment,
    GetClientFeatureFlagsQuery,
    GetClientFeatureFlagsQueryVariables,
    CLIENT_FEATURES_FRAGMENT,
    GET_CLIENT_FEATURE_FLAGS,
    getFragmentData,
} from '@deltasierra/frontend-graphql-core';

export function useClientFeatures(clientId: string | null): {
    clientFeatureFlags: ClientFeaturesFragmentFragment | null;
} {
    const { data } = useSuspenseQuery<GetClientFeatureFlagsQuery, GetClientFeatureFlagsQueryVariables>(
        GET_CLIENT_FEATURE_FLAGS,
        clientId ? { variables: { clientId } } : skipToken,
    );

    return { clientFeatureFlags: getFragmentData(CLIENT_FEATURES_FRAGMENT, data?.client?.features) ?? null };
}
